import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import Link from 'next/link';

import clsx from 'clsx';
import _isEqual from 'lodash/isEqual';

import { removeBasePath } from '@bonnet/next/base-path';

import { useFeatures } from '@atc/features';
import { Breadcrumb as BreadcrumbSchema } from '@atc/react-schemas';

import { Breadcrumbs } from 'reaxl';

import queryDuck from '@/ducks/queryDuck.js';
import srpBreadcrumbsDuck from '@/ducks/srp/srpBreadcrumbsDuck';

function SRPBreadcrumbsContainer() {
    const {
        breadcrumbs: [isBreadcrumbsEnabled] = [],
    } = useFeatures(['breadcrumbs']);

    const breadcrumbs = useSelector(srpBreadcrumbsDuck.selectors.getBreadcrumbs);
    const schemaItems = useSelector(srpBreadcrumbsDuck.selectors.getSchemaItems);
    const query = useSelector(queryDuck.selectors.getDuckState);

    // Reduce the breadcrumb array to only those that have filter values selected
    // NOTE: label will return undefined if no filter is selected
    const getActiveBreadcrumbs = () => breadcrumbs.reduce((acc, crumb) => {
        if (crumb.label) {
            acc.push(crumb);
        }
        // Avoid URLS with the pattern /car-for-sales/YEAR
        if (query.listingType === 'USED' && acc.length === 2) {
            return acc.filter((item) => item.key !== 'year');
        }
        return acc;
    }, []);

    const getActiveSchemaItems = () => schemaItems.reduce((acc, item) => {
        const breadcrumb = breadcrumbs.filter((crumb) => crumb.key === item.key)[0];
        if (breadcrumb.label) {
            acc.push(item);
        }
        // Update Breadcrumbs Schema when URLS with the pattern /car-for-sales/YEAR
        if (query.listingType === 'USED' && acc.length === 2) {
            return acc.filter((element) => element.key !== 'year');
        }
        return acc;
    }, []);

    // TODO: BONNET NEXT - use of removeBasePath is because we re-enabled all
    // internal URLS to still be created with basePath but next/link will re-append
    const renderBreadcrumb = (breadcrumb, i, arr) => (
        <Link
            {...breadcrumb}
            href={removeBasePath(breadcrumb.href)}
            className={
                clsx(
                    {
                        'text-subdued-lighter': i < arr.length - 1 || i === 0,
                        'text-gray-base': i === arr.length - 1,
                    },
                    'text-size-200 padding-right-2 display-inline-block link-undecorated'
                )
            }
        >
            {breadcrumb.label}
        </Link>
    );

    return !!isBreadcrumbsEnabled
        && (
            <div className="flex-1 display-flex justify-content-between">
                <Breadcrumbs
                    data-cmp="breadcrumbs"
                    id="breadcrumbs-container"
                    items={getActiveBreadcrumbs()}
                    render={renderBreadcrumb}
                >
                    <BreadcrumbSchema config={{
                        crumbs: getActiveSchemaItems(),
                    }}
                    />
                </Breadcrumbs>
            </div>
        );
}

export default memo(SRPBreadcrumbsContainer, _isEqual);
